import * as React from "react";
import {useState, useEffect} from "react";
import {
  Button, FormControlLabel,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from "@mui/material";
import {IoMdRefreshCircle} from "react-icons/io";

import FunctionsData from "../../../Functions/FunctionsData";
import 'react-day-picker/lib/style.css';
import {LanguageConfig} from "../../../Functions/LanguageConfig";
import StaffSponsorsAddSponsorCode from "./StaffSponsorsAddSponsorCode";
import StaffSponsorsShowTableRow from "./StaffSponsorsShowTableRow";

export default function StaffSponsorCodes() {

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [dataFiltered, setDataFiltered] = React.useState([]);
  const [currentData, setCurrentData] = React.useState([]);
  const [isOpen, setIsOpen] = React.useState(false);
  const [showInactive, setShowInactive] = React.useState(false);
  const [showArchived, setShowArchived] = React.useState(false);
  const [filter, setFilter] = useState("");
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    FunctionsData.fetchDataGet(
      FunctionsData.getApiUrl('/api/sponsors'),
      setData,
      loading,
      setLoading
    )
  }, [loading]);

  useEffect(() => {
    filterMe();
  }, [data, showInactive, showArchived, refresh, filter]);

  function filterMe() {
    let d = data;
    let newData = [];

    if (filter.trim() !== '') {
      for (let x in d) {
        let obj = d[x];
        let include = false;
        for (let y in obj) {
          let obj2 = obj[y];
          if (String(obj2).toLowerCase().includes(filter.trim().toLowerCase())) {
            include = true;
          }
        }
        if (include === true) {
          newData.push(obj);
        }
      }
      setDataFiltered(newData);
    } else {
      setDataFiltered(data);
    }
  }

  async function updateSponsors(col, val, id) {
    let requestOptionsVoucher = {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'token': sessionStorage.sTkn},
      body: JSON.stringify({ [col]: val })
    };

    await fetch(FunctionsData.getApiUrl("/api/sponsors/update/") + id, requestOptionsVoucher)
      .then(response => response.json())
      .then(() => {
        setLoading(true);
      })
  }

  const openFormNew = () => {
    setCurrentData([]);
    setIsOpen(true);
  }

  const ShowButtonNew = () => {
    return (
      <div>
        <Button sx={{margin: 2}}
                variant={"contained"}
                onClick={openFormNew}
        >
          {LanguageConfig.StaffSponsorCodes_SponsorAddNew}
        </Button>
        <FormControlLabel
          control={<Switch checked={showInactive} onChange={() => setShowInactive(!showInactive)}/>}
          label={LanguageConfig.StaffSponsorCodes_ShowInactive}/>
        <FormControlLabel
          control={<Switch checked={showArchived} onChange={() => setShowArchived(!showArchived)}/>}
          label={LanguageConfig.StaffSponsorCodes_ShowArchived}/>
        <FormControlLabel control={<IoMdRefreshCircle size={35} onClick={() => setLoading(true)}/>} label=""/>
      </div>
    )
  }

  // ---------- NEW: helper to compute voucher stats ----------
  const getVoucherStats = (row) => {
    const toInt = (v) => (v == null || v === '' ? 0 : Number(v));

    const provisioned = toInt(row.sponsor_total_voucher_count);

    const issued =
      toInt(row.issued_voucher_count ?? row.sponsor_issued_count) || provisioned;

    const redeemed =
      toInt(row.sponsor_vouchers ?? row.sponsor_vouchers ?? row.sponsor_vouchers) || 0;

    let available = 0;
    if (row.total_vouchers_left != null) {
      available = toInt(row.total_vouchers_left);
    } else if (row.max_vouchers != null) {
      available = Math.max(0, toInt(row.max_vouchers) - provisioned);
    }

    return { provisioned, issued, redeemed, available };
  };
  // ---------------------------------------------------------

  return (
    <TableContainer>
      <TextField id="standard-basic"
                 placeholder={"Filter sponsors ..."}
                 variant="outlined" size={"small"}
                 sx={{width: '100%'}}
                 value={filter}
                 onChange={(e) => setFilter(e.target.value)}
      />
      <ShowButtonNew setRefresh={setRefresh} refresh={refresh} />

      <StaffSponsorsAddSponsorCode
        setLoading={setLoading}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        currentData={{}}
        mode={"new"}
        key={Date.now()}
        setRefresh={setRefresh}
        refresh={refresh}
      />

      <Table sx={{minWidth: 650}} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{width: '50px'}} align="center">Active</TableCell>
            <TableCell>Logo</TableCell>
            <TableCell>{LanguageConfig.StaffSponsorCodes_SponsorName}</TableCell>
            <TableCell>Program</TableCell>
            <TableCell>Tracking</TableCell>
            <TableCell>Paid on behalf of owner</TableCell>
            <TableCell>Postcodes</TableCell>
            <TableCell align="left">Start</TableCell>
            <TableCell align="left">End</TableCell>
            <TableCell align="left">Vouchers</TableCell><TableCell align="center">Archive</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dataFiltered.map((row, idx) => {
            const tags =
              String(row.postcodes) !== 'null' && String(row.postcodes) !== ''
                ? String(row.postcodes).split(',')
                : [];

            if (showInactive === false && row.active === 0) return null;
            if (showInactive === true && row.active === 1) return null;
            if (showArchived === true && row.archived === 0) return null;
            if (showArchived === false && row.archived === 1) return null;

            return (
              <StaffSponsorsShowTableRow
                key={idx}
                row={row}
                idx={idx}
                tags={tags}
                updateSponsors={updateSponsors}
                setRefresh={setRefresh}
                refresh={refresh}
                setLoading={setLoading}
                vouchersStats={getVoucherStats(row)}
              />
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
